import { cn } from '../../lib/utils';

interface LoadingSpinnerProps {
  size?: 'sm' | 'md' | 'lg';
  className?: string;
  color?: 'primary' | 'white' | 'gray';
}

function LoadingSpinner({ size = 'md', className, color = 'primary' }: LoadingSpinnerProps) {
  const sizeClasses = {
    sm: 'h-4 w-4',
    md: 'h-8 w-8',
    lg: 'h-12 w-12',
  };

  const colorClasses = {
    primary: 'border-primary-600 dark:border-primary-400',
    white: 'border-white',
    gray: 'border-gray-300 dark:border-gray-600',
  };

  return (
    <div className="flex items-center justify-center">
      <div
        className={cn(
          'animate-spin rounded-full border-b-2',
          sizeClasses[size],
          colorClasses[color],
          className
        )}
        aria-label="Carregando..."
        role="status"
      />
    </div>
  );
}

export default LoadingSpinner;